import * as Avo from '@avo/Avo';

export class AvoDispatchOrchestrator {

  public viewTravelHome = Avo.viewTravelHome;
  public viewTravelSearchScreen = Avo.viewTravelSearchScreen;
  public selectTravelSearch = Avo.selectTravelSearch;
  public viewTravelPage = Avo.viewTravelPage;
  public travelOrderConfirmed = Avo.travelOrderConfirmed;
  public proceedToCheckout = Avo.proceedToCheckout;
  public selectCancellationConfirm = Avo.selectCancellationConfirm;
  public viewTravelResultsScreen = Avo.viewTravelResultsScreen;
  public viewTravelReservationDetail = Avo.viewTravelReservationDetail;
  public travelChangesSearchError = Avo.travelChangesSearchError;
  public selectCancellationBanner = Avo.selectCancellationBanner;
  public viewCancellationPage = Avo.viewCancellationPage;
  public travelPackageValidationError = Avo.travelPackageValidationError;
  public selectBanner = Avo.selectBanner;
  public travelLocationNotFound = Avo.travelLocationNotFound;
  public createTravelAlert = Avo.createTravelAlert;
  public viewTravelItemDetail = Avo.viewTravelItemDetail;
  public viewBookingScreen = Avo.viewBookingScreen;
  public travelBookingError = Avo.travelBookingError;
  public travelSearchError = Avo.travelSearchError;
  public travelSeamlessError = Avo.travelSeamlessError;
  public selectFlexdates = Avo.selectFlexdates;
  public viewFlexdates = Avo.viewFlexdates;
  public selectFlexdateOption = Avo.selectFlexdateOption;
  public viewPaxForm = Avo.viewPaxForm;
  public viewInvoicingForm = Avo.viewInvoicingForm;
  public selectChangesSearch = Avo.selectChangesSearch;
  public viewTravelChangesResults = Avo.viewTravelChangesResults;
  public selectChangeOption = Avo.selectChangeOption;
  public selectViewSeatmap = Avo.selectViewSeatmap;
  public viewSeatmapError = Avo.viewSeatmapError;
  public viewSeatmapFlight = Avo.viewSeatmapFlight;
  public selectSeatmapSeat = Avo.selectSeatmapSeat;
  public selectSeatmapSeatRemove = Avo.selectSeatmapSeatRemove;
  public selectSeatmapChange = Avo.selectSeatmapChange;
  public viewTravelAssistanceModal = Avo.viewTravelAssistanceModal;
  public travelPaxEnrollmentSuccess = Avo.travelPaxEnrollmentSuccess;
  public travelPaxEnrollmentError = Avo.travelPaxEnrollmentError;
  public travelUpsellOptionsError = Avo.travelUpsellOptionsError;
  public selectUpsellOptions = Avo.selectUpsellOptions;
  public selectTravelAssistance = Avo.selectTravelAssistance;
  public travelSessionExpired = Avo.travelSessionExpired;
}
